<template>
  <div class="upgradeMain">
    <!-- 顶部 -->
    <div class="top">
      <span class="title">升级申报</span>
    </div>
    <!-- 表格部分 -->
    <el-table
      :data="tableData"
      :key="tableData.length"
      style="width:99%;"
      border
      stripe
      height="520"
    >
      <el-table-column prop="items_name" label="申报项目" align="center"></el-table-column>
      <el-table-column prop="now_award_type" label="申报类型" align="center">
        <template slot-scope="scope">
          <p>{{scope.row.now_award_type === 0 ? '既有建筑初次申报' : '既有建筑升级申报'}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="company_name" label="申报单位" align="center"></el-table-column>
      <el-table-column prop="created_at" label="提交时间" align="center">
        <template slot-scope="scope">
          <p>{{moment(scope.row.created_at).format('YYYY-MM-DD HH:mm:ss')}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="state" label="状态" align="center">
        <template slot-scope="scope">
          <p>{{stateMap[scope.row.state]}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="award_type" label="评奖类型" align="center">
        <template slot-scope="scope">
          <p>{{scope.row.award_type === 1 ? '铂金奖' : scope.row.award_type === 2 ? '金奖' : scope.row.award_type === 3 ? '银奖' : '未获奖'}}</p>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="downloadForm(scope.row)"
            style="text-decoration:underline"
          >下载表格</el-button>
          <el-button type="text" @click="upgrade(scope.row)" style="text-decoration:underline" :disabled="scope.row.award === 1">升级</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :total="total"
      layout="total,sizes,prev,pager,next,jumper"
    ></el-pagination>
  </div>
</template>

<script>
import moment from 'moment'
import { getUserInfo } from '../utils/cache'
import * as API from '../utils/apiService'
import config from '../config'
const { downloadUrl } = config
export default {
  data () {
    return {
      moment,
      stateMap: {
        1: '已提交',
        2: '已形审',
        3: '已初审',
        4: '已评审',
        5: '已评奖',
        6: '退回修改',
        7: '已公示',
        8: '已公告',
        9: '补充资料',
        10: '待提交'
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted () {
    this.asyncQueryExistingbuildingByUseridUpgrade()
  },
  methods: {
    downloadForm (item) {
      let params = {
        id: item.id
      }
      API.downloadDocument(params).then(resp => {
        if (resp.resultCode === '0000') {
          let path = downloadUrl + resp.data
          window.open(path, '_self')
        }
      })
    },
    upgrade (item) {
      if (item.award === 1) {
        this.$message.error('已是铂金奖，无法升级')
      }
      this.$router.push('/writeUpgrade?isUpgrade=true&id=' + item.id)
    },
    // 升级申报表格查询
    asyncQueryExistingbuildingByUseridUpgrade () {
      let params = {
        userid: getUserInfo().id,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      API.queryExistingbuildingByUseridUpgrade(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.tableData = resp.data.list
          this.total = resp.data.total
        }
      })
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.asyncQueryExistingbuildingByUseridUpgrade()
    },
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.asyncQueryExistingbuildingByUseridUpgrade()
    }
  }
}
</script>

<style lang="scss">
.upgradeMain {
}
</style>
